import { Avatar, Box, Button, Grid2, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Typography } from "@mui/material";
import React, { useState } from "react";
import increment from '../../assets/icons/increment.svg';
import decrement from '../../assets/icons/decrement.svg';
import pendingShipment from '../../assets/images/pendingShipment.svg';
import onGoingShipment from '../../assets/images/onGoingShipment.svg';
import totalShipment from '../../assets/images/totalShipment.svg';
import greenTick from '../../assets/images/greenTickSquare.svg';
import assignedShipment from '../../assets/images/Asssigned.svg';
import unassignedShipment from '../../assets/images/UnassignedCard.svg';
import cancelledShipment from '../../assets/images/CancelledCard.svg';
import totalDrivers from '../../assets/images/totalDriversCard.svg';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { makeGetRequestToUrl } from "../commonFunc.jsx";
import { BarChart } from "@mui/x-charts";
import config from '../../config/config.js';
import altProfile from '../../assets/images/altProfile.png';
import dayjs from 'dayjs';
import { useTheme } from '@mui/material/styles';
import prevIcon from '../../assets/icons/left-arrow.svg'
import nextIcon from '../../assets/icons/right-arrow.svg';
import { useNavigate } from "react-router-dom";
import assignedTripIcon from '../../assets/icons/AssignedTripIcon.svg';
import approvedTripIcon from '../../assets/icons/approvedTripsIcon.svg';
import requestedTripIcon from '../../assets/icons/requestedTripsIcon.svg';

const AtDashboard = () => {

    const theme = useTheme();
    const serverUrl = config.serverUrl;
    const navigate = useNavigate();
    const currentDate = dayjs();
    const [driverStatsVal, setDriverStatsVal] = useState("1");
    const [bookingStatsVal, setBookingStatsVal] = useState("1");
    const [headerPeriod, setHeaderPeriod] = useState(1); 
    const [headerData, setHeaderData] = useState([]);
    const [chartData, setChartData] = useState(null);
    const [bookingChartData, setBookingChartData] = useState(null);

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('vehicleName');
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginatedData, setPaginatedData] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [tokenExpired, setTokenExpired] = useState(false);
    const bookingStatusMap = {
        "1": "Unassigned",
        "2": "Assigned",
        "3": "Ongoing",
        "4": "Delivered",
        "5": "Cancelled",
        "6": "Foul Trips"
    };

    const handleInputChange = (e) => {
        setHeaderPeriod(e.target.value);
    };

    const driverStaticsValue = (text) => {
        setDriverStatsVal(text);
    }

    const bookingStaticsValue = (text) => {
        setBookingStatsVal(text);
    }

    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    React.useEffect(() => {
        const paginated = Array.isArray(rows)
            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : [];
        setPaginatedData(paginated);
    }, [rows, page, rowsPerPage]);
    
    const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
    const timeZoneFormat = localStorage.getItem('time_zone_format') || '12';

    React.useEffect(() => {
        const fetchCarDetailsData = async () => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();

                const url = `${serverUrl}/airport/dashboard/card_details`;
                const obj={
                    token: token, timestamp: timestamp, period: headerPeriod
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    setHeaderData(response.data);
                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                    // navigate('/signup');
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchCarDetailsData();
    }, [headerPeriod]);



    React.useEffect(() => {
        const fetchUserStatisticsData = async () => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();

                const url = `${serverUrl}/airport/dashboard/driver_statistics`;
                const obj={
                    token: token, timestamp: timestamp, period: driverStatsVal
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    const userStatisticsData = response.data.driverStatistics;

                    // Use Object.keys for days (x-axis labels)
                    const labels = Object.keys(userStatisticsData); // ['Mon', 'Tues', ...]

                    // Use Object.values for data array (values for each day)
                    const labelsData = Object.values(userStatisticsData); // [{ total: ..., active: ... }, ...]

                    // Extract data series for each metric (e.g., total, active, etc.)
                    const metricKeys = Object.keys(labelsData[0]); // ['total', 'active', 'inactive', 'new_onboard']

                    const formattedSeriesData = metricKeys.map(metric => ({
                        name: metric,
                        data: labels.map(day => userStatisticsData[day][metric]) // Map values for each day
                    }));

                    // Set chart data
                    setChartData({
                        labels: labels, // Use dynamic labels as needed
                        seriesData: formattedSeriesData
                    });
                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchUserStatisticsData();
    }, [driverStatsVal]);

    React.useEffect(() => {
        const fetchBookingStatisticsData = async () => {
            try {
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();

                const url = `${serverUrl}/airport/dashboard/booking_sources`;
                const obj={
                    token: token, timestamp: timestamp, period: bookingStatsVal
                }

                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag == 200 && response.data){
                    const userStatisticsData = response.data.bookingSources;

                    // Use Object.keys for days (x-axis labels)
                    const labels = Object.keys(userStatisticsData); // ['Mon', 'Tues', ...]

                    // Use Object.values for data array (values for each day)
                    const labelsData = Object.values(userStatisticsData); // [{ total: ..., active: ... }, ...]

                    // Extract data series for each metric (e.g., total, active, etc.)
                    const metricKeys = Object.keys(labelsData[0]); // ['total', 'active', 'inactive', 'new_onboard']

                    const formattedSeriesData = metricKeys.map(metric => ({
                        name: metric,
                        data: labels.map(day => userStatisticsData[day][metric]) // Map values for each day
                    }));

                    // Set chart data
                    setBookingChartData({
                        labels: labels, // Use dynamic labels as needed
                        seriesData: formattedSeriesData
                    });
                }
                else if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchBookingStatisticsData();
    }, [bookingStatsVal]);

    const fetchBookingsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/airport/dashboard/booking_statistics';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                status: -1,
                // city_id: cityFilter,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
            }
            if(response.flag==102){
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    React.useEffect(() => {
        fetchBookingsData();
    }, []);

    return(
        <div>
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Dashboard</Typography>

            <Grid2 className="mainBox" sx={{marginTop:'1%'}}>
                <Grid2 item sx={{display:'flex'}}>
                    <Grid2 item>
                        {/* <select style={{minWidth:'180px', padding:'1%', borderRadius:'10px'}} value={headerPeriod} onChange={handleInputChange}>
                            <option value="1">Today</option>
                            <option value="2">Last 7 Days</option>
                            <option value="3">Last 30 Days</option>
                        </select> */}
                        <Select sx={{ marginTop: '2%' }}
                            value={headerPeriod}
                            fullWidth
                            onChange={handleInputChange}
                            style={{ height: '48px', borderRadius: '8px', backgroundColor: '#FFFFFF', width:'200px' }}>

                            <MenuItem value="1">Today</MenuItem>
                            <MenuItem value="2">Last 7 Days</MenuItem>
                            <MenuItem value="3">Last 30 Days</MenuItem>
                        </Select>
                    </Grid2>

                    <Grid2 item sx={{marginLeft:'auto', backgroundColor:'#DDEEFFB2', padding:'0px 8px', borderRadius:'8px', display:'flex', alignItems:'center'}}>
                        <img src={totalShipment} alt="approvedShipment" />
                        <Typography sx={{marginLeft:'4px'}}>Total Bookings : {headerData?.totalBookings?.count}</Typography>
                    </Grid2>
                </Grid2>

                {/* Horizontal Scroll Container */}
                <Grid2
                    container
                    sx={{
                        marginTop: '1%',
                        display: 'grid',
                        gridTemplateColumns: 'repeat(4, 1fr)', // 4 cards per row
                        gap: '20px', // Space between cards
                    }}
                >
                    {/* Card 1: Requested Trips */}
                    <Grid2 item sx={{backgroundColor: '#ECE9FA',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={requestedTripIcon} alt="requestedTrip" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Requested Trips</Typography>
                        {headerData?.requestedBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.requestedBookings?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.requestedBookings?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.requestedBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.requestedBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.requestedBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Card 2: Approved Trips */}
                    <Grid2 item sx={{backgroundColor: '#E1FFF2',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={approvedTripIcon} alt="approvedShipment" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Approved Trips</Typography>
                        {headerData?.approvedBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.approvedBookings?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.approvedBookings?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.approvedBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.approvedBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.approvedBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Card 3: Rejected Trips */}
                    <Grid2 item sx={{backgroundColor: '#FFEDDC',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={pendingShipment} alt="rejectedShipment" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Rejected Trips</Typography>
                        {headerData?.rejectedBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.rejectedBookings?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.rejectedBookings?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.rejectedBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.rejectedBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.rejectedBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Card 4: Unassigned Trips */}
                    <Grid2 item sx={{backgroundColor: '#EEEEEEB2',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={unassignedShipment} alt="unassignedShipment" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Unassigned Trips</Typography>
                        {headerData?.unassignedBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.unassignedBookings?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.unassignedBookings?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.unassignedBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.unassignedBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.unassignedBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Card 5: Assigned Trips */}
                    <Grid2 item sx={{backgroundColor: '#E0FAFFB2',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={assignedTripIcon} alt="assignedTripIcon" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Assigned Trips</Typography>
                        {headerData?.assignedBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.assignedBookings?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.assignedBookings?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.assignedBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.assignedBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.assignedBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Card 6: Ongoing Trips */}
                    <Grid2 item sx={{backgroundColor: '#FFF7D4B2',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={onGoingShipment} alt="onGoingShipment" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Ongoing Trips</Typography>
                        {headerData?.ongoingBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.ongoingBookings?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.ongoingBookings?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.ongoingBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.ongoingBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.ongoingBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Card 7: Completed Trips */}
                    <Grid2 item sx={{backgroundColor: '#DFFFE2B2',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={greenTick} alt="totalShipment" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Completed Trips</Typography>
                        {headerData?.completedBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.completedBookings?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.completedBookings?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.completedBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.completedBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.completedBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                    {/* Card 8: Cancelled Trips */}
                    <Grid2 item sx={{backgroundColor: '#FFDDDDB2',padding: '3%',borderRadius: '12px',minHeight: '150px'}}>
                        <img src={cancelledShipment} alt="onGoingShipment" />
                        <Typography sx={{ fontSize: '16px', color: '#1A1E25' }}>Cancelled Trips</Typography>
                        {headerData?.cancelledBookings && (
                            <Typography
                                sx={{
                                    fontSize: '24px',
                                    color: '#1A1E25',
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}
                            >
                                {headerData.cancelledBookings?.count}
                            </Typography>
                        )}
                        <Grid2 item sx={{ display: 'flex', alignItems: 'center' }}>
                            {headerData?.cancelledBookings?.change >= 0 ? (
                                <img src={increment} alt="increment" />
                            ) : (
                                <img src={decrement} alt="decrement" />
                            )}
                            {headerData?.cancelledBookings && (
                                <Typography
                                    sx={{
                                        color:
                                            headerData.cancelledBookings.change >= 0
                                                ? '#0DBA78'
                                                : '#D14545',
                                        fontSize: '12px',
                                        marginTop: '8px',
                                        marginLeft: '4px',
                                    }}
                                >
                                    {headerData.cancelledBookings.change}%
                                </Typography>
                            )}
                        </Grid2>
                    </Grid2>

                </Grid2>
            </Grid2>

            <Grid2 className="mainBox" sx={{marginTop:'1%'}}>
                <Grid2 item>
                    <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>Booking Source Statistics</Typography>
                </Grid2>
                <hr/>
                <Grid2 item>
                    <Grid2 container>
                        <Grid2 item sx={{marginLeft:'auto'}}>
                            <Button className = {`daysWeeklyMonthly ${bookingStatsVal === '1' ? 'active' : ''}`}
                            onClick={()=>bookingStaticsValue('1')}>Days</Button>

                            <Button className={`daysWeeklyMonthly ${bookingStatsVal === '2' ? 'active' : ''}`} 
                            onClick={()=>bookingStaticsValue('2')}>Weekly</Button>

                            <Button className={`daysWeeklyMonthly ${bookingStatsVal === '3' ? 'active' : ''}`}
                            onClick={()=>bookingStaticsValue('3')}>Monthly</Button>
                        </Grid2>
                    </Grid2>

                    <Grid2 dir={theme.direction}>
                        {bookingChartData && (
                            <BarChart
                                xAxis={[{ scaleType: 'band', data: bookingChartData.labels }]}
                                series={bookingChartData.seriesData}
                                // width={500}
                                height={300}
                            />
                        )}
                    </Grid2>

                    <Grid2 container spacing={10} sx={{backgroundColor:'#F9F9F9', borderRadius:'8px'}}>
                        <Grid2 item sx={{display:'flex', padding:'8px', alignItems:'center'}}>
                            <Grid2 item sx={{display: 'flex', alignItems: 'center'}}>
                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#02B2AF' }}/>
                            </Grid2>
                            <Grid2 item sx={{marginLeft:'2px'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>PIU</Typography>
                            </Grid2>
                        </Grid2>
                        <Grid2 item sx={{display:'flex', padding:'8px', alignItems:'center'}}>
                            <Grid2 item sx={{display: 'flex', alignItems: 'center'}}>
                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#2E96FF' }}/>
                            </Grid2>
                            <Grid2 item sx={{marginLeft:'2px'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Transferz</Typography>
                            </Grid2>
                        </Grid2>
                        <Grid2 item sx={{display:'flex', padding:'8px', alignItems:'center'}}>
                            <Grid2 item sx={{display: 'flex', alignItems: 'center'}}>
                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#B800D8' }}/>
                            </Grid2>
                            <Grid2 item sx={{marginLeft:'2px'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Others</Typography>
                            </Grid2>
                        </Grid2>
                        <Grid2 item sx={{display:'flex', padding:'8px', alignItems:'center'}}>
                            <Grid2 item sx={{display: 'flex', alignItems: 'center'}}>
                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#60009B' }}/>
                            </Grid2>
                            <Grid2 item sx={{marginLeft:'2px'}}>
                                <Typography sx={{color:'#60009B', fontSize:'14px'}}>Admin Panel</Typography>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>

            <Grid2 className="mainBox" sx={{marginTop:'1%'}}>
                <Grid2 item>
                    <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>Driver Statistics</Typography>
                </Grid2>
                <hr/>

                <Grid2 item>

                    <Grid2 container>
                        <Grid2 item sx={{marginLeft:'auto'}}>
                            <Button className = {`daysWeeklyMonthly ${driverStatsVal === '1' ? 'active' : ''}`}
                            onClick={()=>driverStaticsValue('1')}>Days</Button>

                            <Button className={`daysWeeklyMonthly ${driverStatsVal === '2' ? 'active' : ''}`} 
                            onClick={()=>driverStaticsValue('2')}>Weekly</Button>

                            <Button className={`daysWeeklyMonthly ${driverStatsVal === '3' ? 'active' : ''}`}
                            onClick={()=>driverStaticsValue('3')}>Monthly</Button>
                        </Grid2>
                    </Grid2>

                    <Grid2 dir={theme.direction}>
                        {chartData && (
                            <BarChart
                                xAxis={[{ scaleType: 'band', data: chartData.labels }]}
                                series={chartData.seriesData}
                                // width={500}
                                height={300}
                            />
                        )}
                    </Grid2>

                    <Grid2 container spacing={4} sx={{backgroundColor:'#F9F9F9', borderRadius:'8px'}}>
                        <Grid2 item sx={{display:'flex', padding:'8px', alignItems:'center'}}>
                            <Grid2 item sx={{display: 'flex', alignItems: 'center'}}>
                                <FiberManualRecordIcon style={{ fontSize: '16px', color:'#02B2AF' }}/>
                            </Grid2>
                            <Grid2 item sx={{marginLeft:'2px'}}>
                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Total Drivers</Typography>
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>

            <Grid2 className="mainBox" sx={{marginTop:'1%'}}>
                <Grid2 item container>
                    <Typography sx={{fontSize:'24px', color:'#1A1E25', paddingTop:'1%'}}>New Requested Bookings</Typography>
                    <Grid2 item onClick={() => navigate('/airport-transfer-booking')} sx={{marginLeft:'auto', border:'1px solid #D1D5DB', backgroundColor:'#F9F9F9', borderRadius:'8px', width:'100px', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer'}}>
                        <Typography sx={{color:'#4E545D', fontSize:'16px', width:'100%', textAlign:'center'}}>View All</Typography>
                    </Grid2>
                </Grid2>
                <hr/>
                <Grid2 item>
                    <Grid2 dir={theme.direction}>
                        <TableContainer className="table-container" sx={{ maxHeight:'70vh' }}>
                            <Table stickyHeader className="scrollable-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel
                                                active={orderBy === 'booking_id'}
                                                direction={orderBy === 'booking_id' ? order : 'asc'}
                                                onClick={() => handleRequestSort('booking_id')}
                                            >
                                                Booking ID
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel
                                                active={orderBy === 'source'}
                                                direction={orderBy === 'source' ? order : 'asc'}
                                                onClick={() => handleRequestSort('source')}
                                            >
                                                Booking Mode
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel
                                                active={orderBy === 'user_first_name'}
                                                direction={orderBy === 'user_first_name' ? order : 'asc'}
                                                onClick={() => handleRequestSort('user_first_name')}
                                            >
                                                User
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel
                                                active={orderBy === 'user_email'}
                                                direction={orderBy === 'user_email' ? order : 'asc'}
                                                onClick={() => handleRequestSort('user_email')}
                                            >
                                                User Email
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel
                                                active={orderBy === 'phone_no'}
                                                direction={orderBy === 'phone_no' ? order : 'asc'}
                                                onClick={() => handleRequestSort('phone_no')}
                                            >
                                                Date & Time
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel
                                                active={orderBy === 'distance'}
                                                direction={orderBy === 'distance' ? order : 'asc'}
                                                onClick={() => handleRequestSort('distance')}
                                            >
                                                Distance (in km)
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel
                                                active={orderBy === 'duration'}
                                                direction={orderBy === 'duration' ? order : 'asc'}
                                                onClick={() => handleRequestSort('duration')}
                                            >
                                                Duration (in min)
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            <TableSortLabel
                                                active={orderBy === 'ticket_count'}
                                                direction={orderBy === 'ticket_count' ? order : 'asc'}
                                                onClick={() => handleRequestSort('ticket_count')}
                                            >
                                               Number of Seats
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                            Status
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {rows.length === 0 && (
                                        <TableRow>
                                            <TableCell colSpan={14} align="center">
                                                <Typography variant="body1">No data found</Typography>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {(rowsPerPage > 0
                                        ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        : rows
                                    ).map((row) => {

                                        return(
                                            <TableRow key={row.tms_client_id}>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row?.booking_id}</Typography></TableCell>
                                                <TableCell align="center">
                                                    <Typography sx={{ minWidth: '100px', color: row.source==1 ? '#0C3B7C' : row.source==2 ? '#AC8312' : row.source==0 ? '#8f8c81' : row.source==-1 ? '#0065FF' : '#0065FF' }}>{row.source==1 ? 'PIU' : row.source==2 ? 'Transferz' : row.source==0 ? 'Others' : row.source==-1 ? 'Admin Panel' : 'Unknown'}</Typography>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid2 container sx={{ width: "auto", minWidth: "180px" }}>
                                                        <Grid2>
                                                            {row.user_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={row.user_image}></Avatar>
                                                            }
                                                            {!row.user_image && <Avatar sx={{ borderColor: "#0065FF", border: 1 }} alt='name' src={altProfile}></Avatar>
                                                            }
                                                        </Grid2>
                                                        <Grid2 item sx={{ ml: "8px", textAlign: "left" }}>
                                                            <Grid2><Typography>{row.user_first_name + ' ' + row.user_last_name}</Typography></Grid2>
                                                            <Grid2><Typography sx={{ color: "#83888E", fontSize: "12px" }}>{row.user_phone_number}</Typography></Grid2>
                                                        </Grid2>
                                                    </Grid2>
                                                </TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.user_email}</Typography></TableCell>
                                                <TableCell align="center">
                                                    <Typography sx={{ minWidth: '100px' }}>
                                                        {row.pickup_time ? 
                                                        (() => {
                                                            const pickupDate = new Date(row.pickup_time);
                                                            // Add the offset minutes to the date
                                                            pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                                                            return pickupDate.toLocaleString('en-GB', {
                                                            day: '2-digit', 
                                                            month: '2-digit', 
                                                            year: 'numeric', 
                                                            hour: '2-digit', 
                                                            minute: '2-digit', 
                                                            hour12: timeZoneFormat == '12' ? true : false,
                                                            timeZone: 'UTC'
                                                            }).replace(',', ' |');
                                                        })() 
                                                        : '--'
                                                        }
                                                    </Typography>
                                                </TableCell>
                                                
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.distance}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.duration}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.ticket_count ? row.ticket_count : '--'}</Typography></TableCell>
                                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', 
                                                    color: row.booking_status === 1 ? '#F5BB19' : 
                                                    row.booking_status === 2 ? '#36C68F' : 
                                                    row.booking_status === 3 ? '#D14545' : row.booking_status === 4 ? '#ff843d' : row.booking_status === 5 ? '#C71F1F' : row.booking_status === 6 ? 'green' : 'transparent',
                                                    }}>
                                                    {row.booking_status==1 ? 'Pending' : row.booking_status==2 ? 'Accepted' : row.booking_status==3 ? 'Rejected' : row.booking_status==4 ? 'Missed' : row.booking_status==5 ? 'Cancelled' : row.booking_status==6 ? 'Assigned' : 'Unknown'}</Typography>
                                                </TableCell>
                                                
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                            <div className="custom-pagination">
                                <div className="pagination-info">
                                    {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                                        (page + 1) * rowsPerPage,
                                        rows.length
                                    )} of ${rows.length} entries`}
                                </div>
                                <div className="pagination-controls">
                                    <button
                                        onClick={() => handleChangePage(null, page - 1)}
                                        disabled={page === 0}
                                        className="pagination-arrow"
                                    >
                                        <img src={prevIcon} alt="Previous" />
                                    </button>
                                    <div className="pagination-numbers">
                                        {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                            <button key={index} onClick={() => handleChangePage(null, index)}
                                                className={`pagination-number ${page === index ? 'active' : ''}`}>
                                                {index + 1}
                                            </button>
                                        ))}
                                    </div>
                                    <button
                                        onClick={() => handleChangePage(null, page + 1)}
                                        disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                                        className="pagination-arrow"
                                    >
                                        <img src={nextIcon} alt="Next" />
                                    </button>
                                </div>
                            </div>
                        </TableContainer>
                    </Grid2>
                </Grid2>
            </Grid2>
        </div>
    )
}

export default AtDashboard;